import { Counter } from 'graphql-common';
import FieldNames from '@lib/enums/fieldNames/assetCounterFieldNames';
import { TFunction } from 'i18next';
import {
  getMeasureTypeOptions,
  getMeasureUnitOptionsByType,
} from '@lib/utils/measure';

type Args = {
  data?: Counter;
  t: TFunction<'translation', undefined>;
};

export default function getDefaultCounterFormValuesFromQueryData({
  data,
  t,
}: Args) {
  const measureType = data?.measureType;
  const measureUnit = data?.measureUnit;
  const typeLabelKey = getMeasureTypeOptions().find(
    ({ value }) => value === measureType,
  )?.labelKey;
  const unitLabelKey = getMeasureUnitOptionsByType(measureType).find(
    ({ value }) => value === measureUnit,
  )?.labelKey;
  return {
    [FieldNames.Name]: data?.name,
    [FieldNames.Code]: data?.code,
    [FieldNames.MeasureType]:
      typeLabelKey && measureType
        ? {
            label: t(typeLabelKey),
            value: measureType,
          }
        : undefined,
    [FieldNames.MeasureUnit]:
      unitLabelKey && measureUnit
        ? {
            label: t(unitLabelKey),
            value: measureUnit,
          }
        : undefined,
    [FieldNames.ProhibitLowerIndexThanPrevious]:
      data?.prohibitLowerIndexThanPrevious,
    // Custom renders
    [FieldNames.ProhibitLowerIndexThanPreviousField]: null,
  };
}
